export default "__VITE_ASSET__Caw_QN3k__"